// extracted by mini-css-extract-plugin
module.exports = {"headline":"FormHeadline_headline_1BPuI"};